import { render } from "./DeleteCargoModal.vue?vue&type=template&id=6e0c9f6d"
import script from "./DeleteCargoModal.vue?vue&type=script&lang=js"
export * from "./DeleteCargoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__